/**
 * Idiomas que a página atual NÃO deve declarar no hreflang. O `layouts/MetaTags.vue`
 * publica os alternates `en`, `pt-br` e `x-default` em toda página; quando um
 * idioma não tem equivalente (ex.: categoria de coluna sem artigo em inglês, cujo
 * /en dá 404), a página informa aqui e o MetaTags tira o alternate.
 *
 * Guardado por caminho da rota: o que uma página marca não vale para a próxima na
 * navegação pelo cliente, sem precisar limpar. O `x-default` aponta para o pt-br,
 * então sai junto com ele.
 */
export function useHreflangAusenteEstado() {
  return useState<Record<string, string[]>>("hreflang-ausente", () => ({}));
}

export function useHreflangAusente(idiomas: string[]) {
  const route = useRoute();
  const estado = useHreflangAusenteEstado();
  estado.value = { ...estado.value, [route.path]: idiomas };
}
